import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IRoomsDAO } from '../../../../api/rooms.dao';

export class GenerateRoomsJob extends JobConfiguration {
    public readonly type = JobType.GenerateRooms;
    public readonly name = 'Create & Assign Rooms';
    public readonly description = 'Creating & Assigning Rooms';

    public async execute(execParams) {
        return IoC.Container.get(IRoomsDAO).generateRooms(execParams);
    }
}

export default {
    [JobType.GenerateRooms]: GenerateRoomsJob
};
